import React, { useState } from "react";
import { logoutUser } from "../../services/authService";
import logoDark from "../../assets/images/radarlogo.png";

import "./navigation.css"; // Import your CSS file for styling
import { Link, useNavigate } from "react-router-dom";

function NavigationBar() {
  const navigate = useNavigate();

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const token = localStorage.getItem("accessToken");

  return (
    <nav className="navbar">
      <div className="nav-left">
        <img
          src={logoDark}
          alt="Logo"
          height={24}
          onClick={() => navigate("/")}
        />
        <div
          className="dropdown"
          onMouseEnter={() => setIsDropdownOpen(true)}
          onMouseLeave={() => setIsDropdownOpen(false)}
        >
          <button className="dropbtn">Help</button>
          {isDropdownOpen && (
            <div className="dropdown-content">
              <a href="/faq" className="dropdown-item">
                FAQ
              </a>
              <a href="#contact" className="dropdown-item">
                Contact Us
              </a>
            </div>
          )}
        </div>
        <a href="/pricing" className="nav-link">
          Pricing
        </a>
        <a href="/about-us" className="nav-link">
          About Us
        </a>
        <Link to="/demos" className="nav-link">
          Demo Videos
        </Link>
        <a href="/marketplace" className="nav-link">
          Marketplace
        </a>
      </div>
      <div className="nav-right">
        {!token ? (
          <>
            <a href="/login" className="nav-link-underline">
              Login
            </a>
            <a href="/register" className="nav-link-underline">
              Signup
            </a>
          </>
        ) : (
          <>
            <a href="/home" className="nav-link-underline">
              Dashboard
            </a>
            <a href="/" className="nav-link-underline" onClick={logoutUser}>
              Logout
            </a>
          </>
        )}
      </div>
    </nav>
  );
}

export default NavigationBar;
